import { Box, CircularProgress } from '@mui/material';
import React from 'react';
const Submitting = () => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Submitting;
